<template>
  <vertical-space :top="responsiveTop" :bottom="responsiveBottom" :backgroundColor="bgColor">
    <div class="single-image" :class="{ 'fullpage': fullpage, 'full-height': fullHeight }">
      <h2 v-if="text" :style="{color: textColor}">{{ text }}</h2>

      <scroll-speed :speed="speed">
        <div slot-scope="{}" class="parallax" :style="{'padding-bottom': imageSizeRatio }">
          <img
            :style="{'max-width': accualWidth + 'vw'}"
            class="single-image__wrapper lazy"
            :src="image"
          />
        </div>
      </scroll-speed>
    </div>
  </vertical-space>
</template>

<script>
import { mapState } from "vuex";
import scrollSpeed from "@/components/scroll-speed.vue";
import verticalSpace from "@/components/vertical-space.vue";
// import LazyLoad from "vanilla-lazyload";

export default {
  name: "CaseViewSingleImage",
  components: { scrollSpeed, verticalSpace },
  props: {
    bgColor: String,
    image: String,
    text: String,
    textColor: String,
    fullpage: Boolean,
    fullHeight: Boolean,
    maxWidth: { type: Number, default: 100 },

    marginTop: { type: Number, default: 0 },
    marginBottom: { type: Number, default: 0 }
  },
  data() {
    return {
      imageSizeRatio: 0,
      speed: this.fullpage ? 1 : 1.1
    };
  },
  computed: mapState({
    smallScreen: state => state.globals.smallScreen,
    accualWidth() {
      return this.smallScreen ? 100 : this.maxWidth;
    },
    responsiveTop() {
      return this.smallScreen ? this.marginTop / 2 : this.marginTop;
    },
    responsiveBottom() {
      return this.smallScreen ? this.marginBottom / 2 : this.marginBottom;
    }
  }),
  methods: {
    getImageMeta(url) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      });
    },
    getImageSizeRatio(dataRef, image) {
      return this.getImageMeta(image).then(meta => {
        const ratio =
          (meta.height / meta.width) * 100 * (this.accualWidth / 100) + "%";
        this[dataRef] = ratio;
      });
    }
  },
  mounted() {
    // new LazyLoad({
    // 	elements_selector: ".lazy"
    // })
    this.getImageSizeRatio("imageSizeRatio", this.image);
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.single-image {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 $margin1-8;

  @media screen and (min-width: 768px) {
    padding: 0 $margin1-1;
  }

  @media screen and (min-width: 1024px) {
    padding: 0 $margin4-1;
  }

  h2 {
    @include typeset(body-medium);
    @include typeface(expanded);

    position: absolute;
    top: 7.3vw;
    left: 9.3vw;
    z-index: 2;

    @media screen and (max-width: 550px) {
      top: 6vw;
    }

    @media screen and (max-width: 440px) {
      left: 20px;
    }
  }

  .parallax {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &.max-width {
      max-width: 1560px;
    }

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &.fullpage {
    padding: 0;
  }

  &.full-height {
    min-height: 100vh;
    box-sizing: border-box;
  }

  &.vertical-padding {
    padding: $margin1-1 0;
    @media screen and (min-width: 769px) {
      padding: $margin2-1;
    }
  }

  &__wrapper {
    width: 100%;
    height: auto;

    background: center / cover no-repeat;
  }
}
</style>
